<template>
  <div class="single-view green-spirit">
    <view-background
      ref="background"
      :background="background"/>

    <hero-block
      :title="title"
      :subtitle="subtitle"
      :animate-in="entering"
      :animation-direction="animationDirection" />

    <content-wrapper>
      <one-column-content>
        <header class="block--header">
          <h2>Processo e controllo sono i genitori del risultato.</h2>
        </header>

        <div class="block--content">
          <h3>La qualità del sistema</h3>
          <h4>La qualità gestita in conformità alle norme ISO ed ai documenti prescrittivi ACCREDIA, è un'attività consolidata in POLOLAB, che ci permette di garantire la soddisfazione dei nostri clienti.</h4>

          <p>
            Il sistema che adottiamo è in costante evoluzione ed è stato ottenuto definendo e sviluppando obiettivi mirati, identificando specifici indicatori di qualità il cui monitoraggio ci permette di analizzare criticamente i diversi processi aziendali. L'esito consente la pianificazione degli interventi di miglioramento ed il potenziamento dell'efficienza della struttura.
          </p>

          <figure>
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/qualita/quality-check.jpg')">
              <img :src="require('@/assets/qualita/quality-check.jpg')" alt="Sostenibilità Rossetto">
            </picture>
          </figure>
          <br />
          <h4>I nostri principali obiettivi</h4>

          <ul>
            <li><p><strong>Soddisfazione del cliente.</strong> Le esigenze e le aspettative del cliente vengono raccolte, esaminate e valutate al fine di adattare ad esse gli obiettivi programmatici dell'azienda.</p></li>
            <li><p><strong>Il riesame della politica della qualità.</strong> Annualmente viene svolto un riesame critico della politica della qualità allo scopo di valutarne il reale livello di attuazione, la coerenza e l'efficacia rispetto ai riferimenti organizzativi, economici e legislativi che regolano l'attività aziendale.</p></li>
            <li><p><strong>Condivisione dei principi.</strong> La politica della qualità è trasversale e condivisa a tutti i livelli organizzativi aziendali. Periodicamene viene illustrata e discussa con i collaboratori al fine di garantirne la piena comprensione e attuazione.</p></li>
            <li><p><strong>Sicurezza.</strong> La gestione de rischio finalizzata alla sicurezza del personale è per POLOLAB una priorità strategica, finalizzata alla prevenzione degli errori e alla mitigazione degli eventuali effetti dannosi.</p></li>
            <li><p><strong>Avanguardia tecnologica.</strong> Offrire servizi d'eccellenza, in linea con le migliori pratiche disponibili a livello internazionale rinnovando costantemente le dotazioni aziendali così da elevarne i risultati scientifici e tecnologici.</p></li>
            <li><p><strong>Ambiente di lavoro.</strong> Predisporre un ambiente che garantisca il benessere, per mezzo di strutture confortevoli e adeguate, per favorire un clima relazionale efficace e favorevole alla collaborazione e allo scambio delle informazioni.</p></li>
            <li><p><strong>Standardizzazione dei processi.</strong> Nel rispetto delle norme più recenti, mantenere elevato lo standard di servizio mediante il continuo monitoraggio e miglioramento dei processi.</p></li>
          </ul>

          <accordion :elements="accordionData" />
        </div>
      </one-column-content>
    </content-wrapper>
    <global-footer />
  </div>
</template>

<script>
import guards from './SingleView/guards'
import garbage from './SingleView/garbage'
import backgrounds from './SingleView/backgrounds'
import HeroBlock from '../components/HeroBlock'
import ContentWrapper from '../components/ContentWrapper'
import GlobalFooter from '../components/GlobalFooter'
import OneColumnContent from '../components/ContentWrapper/OneColumnContent'
import Accordion from '../components/Accordion'
import RossettoButton from '../components/RossettoButton'
import ViewBackground from '../components/ViewBackground'
import VisualCounter from '../components/VisualCounter'
import Slider from '../components/Slider'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import _ from 'lodash'

export default {
  mixins: [ guards, garbage, backgrounds ],
  components: {
    HeroBlock,
    ContentWrapper,
    GlobalFooter,
    OneColumnContent,
    Accordion,
    RossettoButton,
    ViewBackground,
    VisualCounter,
    Slider
  },
  data: () => ({
    title: 'Sistema di qualità',
    subtitle: 'I punti cardinali ai quali facciamo riferimento. Ogni giorno.',
    bgName: 'greenSpirit',
    slides: require('./Company/slider-loghi.json'),
    bgOptions: {
      wave: {
        horizontalSpread: 10,
        verticalSpread: 5
      }
    }
  }),
  computed: {
    ...mapGetters('certificates', [
      'list'
    ]),
    accordionData: {
      get () {
        return _.map(this.list, ({ id, title, text }) => ({
          title,
          content: text,
          id: 'cert' + id
        }))
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(async vm => {
      await vm.getCertificates()
    })
  },
  methods: {
    ...mapMutations('animations', [
      'addPixiApp',
      'updateMouseCursor'
    ]),
    ...mapActions('certificates', [
      'getCertificates'
    ])
  },
  metaInfo: {
    title: 'Spirito Green',
    meta: [
      {
        name: 'description',
        content: ''
      }
    ]
  }
}
</script>

<style lang="scss">
.green-spirit {
  .block--header {
    h2 {
      max-width: 870px;
    }
  }
}
</style>
